export const endemicity = [
  {
    "IU code": "ETH0194618714",
    "IU name": "Abobo",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194618722",
    "IU name": "Jore",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194618723",
    "IU name": "Lare",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919043",
    "IU name": "Adadle",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919045",
    "IU name": "Ararso",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919051",
    "IU name": "Berocano",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919054",
    "IU name": "Elwayne",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919056",
    "IU name": "Degehabur",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919058",
    "IU name": "Degehamedo",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919059",
    "IU name": "Dembel",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919060",
    "IU name": "Danod",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919066",
    "IU name": "Dolo Odo",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919068",
    "IU name": "Dihun",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919076",
    "IU name": "Gashamo",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919079",
    "IU name": "Goljano",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919083",
    "IU name": "Gursum (Somali)",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919085",
    "IU name": "Hamero",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919090",
    "IU name": "Jigjiga City",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919094",
    "IU name": "Kebridehar",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919096",
    "IU name": "Lagahida",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919105",
    "IU name": "Raso",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919111",
    "IU name": "Tuliguled",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019116",
    "IU name": "Amaro",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019118",
    "IU name": "Arba Minch Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219122",
    "IU name": "Aleta Wondo Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319126",
    "IU name": "Anderacha",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019128",
    "IU name": "Arba Minch Zuria",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019138",
    "IU name": "Bena Tsemay",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319141",
    "IU name": "Bita (Big)",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019145",
    "IU name": "Bule",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019149",
    "IU name": "Cheha",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319150",
    "IU name": "Chena",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019153",
    "IU name": "Denibu Gofa",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019158",
    "IU name": "Daramalo",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019159",
    "IU name": "Derashe Special",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019164",
    "IU name": "Damboya",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219165",
    "IU name": "Dara",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019169",
    "IU name": "Dila City Admin",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019170",
    "IU name": "Dila Zuria",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319178",
    "IU name": "Esira",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019181",
    "IU name": "Gedeb",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219190",
    "IU name": "Gorche",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019197",
    "IU name": "Hamer",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219199",
    "IU name": "Hawassa Zuria",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219200",
    "IU name": "Tula Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019207",
    "IU name": "Kemba",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019212",
    "IU name": "Kebena",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019213",
    "IU name": "Kochere",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019216",
    "IU name": "Limu (SNNP)",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219217",
    "IU name": "Loka Abaya",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319218",
    "IU name": "Lome (SNNP)",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194118487",
    "IU name": "Addis Ketema",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194118488",
    "IU name": "Akaki - Kalit",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194118489",
    "IU name": "Arada",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194118490",
    "IU name": "Bole",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194118491",
    "IU name": "Gulele",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194118492",
    "IU name": "Kirkos",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194118493",
    "IU name": "Kolfe - Keran",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194118494",
    "IU name": "Lideta",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194118495",
    "IU name": "Nefas Silk",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194118496",
    "IU name": "Yeka",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218497",
    "IU name": "Aba 'Ala",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218498",
    "IU name": "Adaa'r",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218499",
    "IU name": "Afambo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218500",
    "IU name": "Afdera",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218503",
    "IU name": "Awash Fentale",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218504",
    "IU name": "Awash City",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218505",
    "IU name": "Awra",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218507",
    "IU name": "Berahile",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218508",
    "IU name": "Bidu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218509",
    "IU name": "Gelealo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218510",
    "IU name": "Chifra",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218511",
    "IU name": "Dalifage",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218512",
    "IU name": "Dalol",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218514",
    "IU name": "Dubti",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218516",
    "IU name": "Elidar",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218517",
    "IU name": "Erebti",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218518",
    "IU name": "Ewa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218520",
    "IU name": "Gewane",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218521",
    "IU name": "Gulina",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218522",
    "IU name": "Hadelela",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218523",
    "IU name": "Kunneba",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218524",
    "IU name": "Kurri",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218525",
    "IU name": "Megale",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218526",
    "IU name": "Mile",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218527",
    "IU name": "Logiya-Semera",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218528",
    "IU name": "Samurobi Gele'alo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218529",
    "IU name": "Telalak",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218530",
    "IU name": "Teru",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218531",
    "IU name": "Yalo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318534",
    "IU name": "Albuko",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318539",
    "IU name": "Angolelana Tera",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194218543",
    "IU name": "Arguba Special",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318545",
    "IU name": "Assagirt",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318549",
    "IU name": "Banja",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318551",
    "IU name": "Basona Worena",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318559",
    "IU name": "Bure Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318563",
    "IU name": "Debre Elias",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318564",
    "IU name": "Debre Markos Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318565",
    "IU name": "Dessie Zuria",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318567",
    "IU name": "Dangila",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318568",
    "IU name": "Dangila Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318571",
    "IU name": "Debark",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318575",
    "IU name": "Debre Berhan Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318576",
    "IU name": "Semen Achefer",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318577",
    "IU name": "Dega Damot",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318578",
    "IU name": "Dehana",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318581",
    "IU name": "Dembecha",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318584",
    "IU name": "Dessie City Adm.",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318588",
    "IU name": "Enarj Enawga",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318590",
    "IU name": "Enemay",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318591",
    "IU name": "Ensaro",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318593",
    "IU name": "Fagta Lakoma",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318594",
    "IU name": "Farta",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318596",
    "IU name": "Fogera",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318597",
    "IU name": "Gaz Gibla",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318599",
    "IU name": "Gidan",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318600",
    "IU name": "Gishe Rabel",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318601",
    "IU name": "Goncha Siso Enebse",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318605",
    "IU name": "Guzamn",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318607",
    "IU name": "Guangua",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318608",
    "IU name": "Guba Lafto",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318610",
    "IU name": "Habru",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318611",
    "IU name": "Hagere Mariam",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318612",
    "IU name": "Injibara Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318615",
    "IU name": "Janamora",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318624",
    "IU name": "Kutaber",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318628",
    "IU name": "Lay Gayint",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318631",
    "IU name": "Mehal Sayint",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318632",
    "IU name": "Michakel",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318638",
    "IU name": "Menze Lalo Midir",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318639",
    "IU name": "Menze Mama Midir",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318640",
    "IU name": "Merhabete",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318642",
    "IU name": "Mida Woremo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318643",
    "IU name": "Minjar Shenkora",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318647",
    "IU name": "Mojan Wedera",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318648",
    "IU name": "Moretna Jiru",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318651",
    "IU name": "Quarit",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318653",
    "IU name": "Sayint",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318655",
    "IU name": "Sahila",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318662",
    "IU name": "Senan",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318663",
    "IU name": "Sekela",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318664",
    "IU name": "Tach Gayint",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318669",
    "IU name": "Tenta",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318672",
    "IU name": "Wadla",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318676",
    "IU name": "Worebabu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318677",
    "IU name": "Woreta Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318679",
    "IU name": "Zigem",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194318680",
    "IU name": "Zequala",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818738",
    "IU name": "Ameya",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818742",
    "IU name": "Abichugna Gne'a",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818743",
    "IU name": "Abuna G/Beret",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818744",
    "IU name": "Adaba",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818748",
    "IU name": "Adda Berga",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818755",
    "IU name": "Aleltu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818756",
    "IU name": "Alge Sachi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818758",
    "IU name": "Ambo Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818761",
    "IU name": "Ana Sora",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818763",
    "IU name": "Anfilo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818766",
    "IU name": "Arsi Negele Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818767",
    "IU name": "Aseko",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818770",
    "IU name": "Boji Chekorsa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818774",
    "IU name": "Begi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818777",
    "IU name": "Bako Tibe",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818778",
    "IU name": "Bele Gesgar",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818780",
    "IU name": "Becho (SW Shewa)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818782",
    "IU name": "Bedele Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818784",
    "IU name": "Bekoji Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818785",
    "IU name": "Berbere",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818786",
    "IU name": "Bereh",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818787",
    "IU name": "Bilo Nopha",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818791",
    "IU name": "Boneya Boshe",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818793",
    "IU name": "Bore",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818795",
    "IU name": "Boset",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818798",
    "IU name": "Burayu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818801",
    "IU name": "Cheliya",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818807",
    "IU name": "Chora (Buno Bedele)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818808",
    "IU name": "Chora (Jimma)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818809",
    "IU name": "Dawo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818811",
    "IU name": "Dale Sadi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818813",
    "IU name": "Afele Kola (Dima)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818814",
    "IU name": "Dano",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818815",
    "IU name": "Darimu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818817",
    "IU name": "Debre Libanos",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818824",
    "IU name": "Denbi Dollo Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818825",
    "IU name": "Dendi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818829",
    "IU name": "Dhas",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818830",
    "IU name": "Dedesa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818831",
    "IU name": "Didu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818833",
    "IU name": "Degeluna Tijo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818835",
    "IU name": "Dilo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818838",
    "IU name": "Tikur Enchini",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818840",
    "IU name": "Dodola",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818841",
    "IU name": "Dodola Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818842",
    "IU name": "Dodota",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818843",
    "IU name": "Dorani",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818845",
    "IU name": "Dugda Dawa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818846",
    "IU name": "Dukem",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818847",
    "IU name": "Ibantu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818851",
    "IU name": "Fiche Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818852",
    "IU name": "Gaji",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818856",
    "IU name": "Goro (Bale)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818857",
    "IU name": "Guliso",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818858",
    "IU name": "Gedeb Asasa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818860",
    "IU name": "Gawo Kebe",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818861",
    "IU name": "Gechi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818862",
    "IU name": "Gelana (Finfine)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818863",
    "IU name": "Gelana (West Guji)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818865",
    "IU name": "Gera",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818867",
    "IU name": "Gidami",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818868",
    "IU name": "Ginde Beret",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818871",
    "IU name": "Gerar Jarso",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818873",
    "IU name": "Goba",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818874",
    "IU name": "Goba Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818875",
    "IU name": "Gobu Seyo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818883",
    "IU name": "Bila Seyo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818891",
    "IU name": "Inkolo Wabe",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818894",
    "IU name": "Ababo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818899",
    "IU name": "Haro Limu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818904",
    "IU name": "Hitosa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818908",
    "IU name": "Hurumu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818909",
    "IU name": "Ilu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818911",
    "IU name": "Illu Galan",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818913",
    "IU name": "Jarte Jardega",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818917",
    "IU name": "Jibat",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818919",
    "IU name": "Jimma Arjo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818920",
    "IU name": "Jimma Genete",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818921",
    "IU name": "Jimma Horo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818922",
    "IU name": "Jimma Rare",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818925",
    "IU name": "Kersana Malima",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818929",
    "IU name": "Kiremu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818930",
    "IU name": "Kofele",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818931",
    "IU name": "Kokosa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818933",
    "IU name": "Kore",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818936",
    "IU name": "Lalo Asabi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818937",
    "IU name": "Limu Bilbilo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818938",
    "IU name": "Lude Hitosa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818940",
    "IU name": "Lome (Oromia)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818941",
    "IU name": "Lalo Kile",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818944",
    "IU name": "Leka Dulecha",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818946",
    "IU name": "Limu Seka",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818948",
    "IU name": "Limu (Oromia)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818950",
    "IU name": "Metehara Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818951",
    "IU name": "Mojo Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818952",
    "IU name": "Meko",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818961",
    "IU name": "Metu Zuria",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818967",
    "IU name": "Miyo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818969",
    "IU name": "Mulo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818970",
    "IU name": "Munessa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818973",
    "IU name": "Nole Kaba",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818978",
    "IU name": "Nono Benja",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818979",
    "IU name": "Sale Nono",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818980",
    "IU name": "Nunu Kumba",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818985",
    "IU name": "Rayitu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818986",
    "IU name": "Robe",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818988",
    "IU name": "Sayo Nole",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818989",
    "IU name": "Seden Sodo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818990",
    "IU name": "Sodo Daci",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818993",
    "IU name": "Sebeta Hawas",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818994",
    "IU name": "Sebeta /Town/",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818996",
    "IU name": "Sendafa Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818998",
    "IU name": "Setema",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194818999",
    "IU name": "Seweyna",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819000",
    "IU name": "Sayo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819002",
    "IU name": "Shala",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819004",
    "IU name": "Shashemene Zuria",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819005",
    "IU name": "Shebe Sambo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819006",
    "IU name": "Shirka",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819007",
    "IU name": "Sibu Sire",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819010",
    "IU name": "Siraro",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819011",
    "IU name": "Sire",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819012",
    "IU name": "Sekoru",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819014",
    "IU name": "Sululta",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819015",
    "IU name": "Sululta Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819016",
    "IU name": "Tole",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819017",
    "IU name": "Teltale",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819018",
    "IU name": "Tena",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819020",
    "IU name": "Tiyo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819024",
    "IU name": "Waliso",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819026",
    "IU name": "Wenchi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819028",
    "IU name": "Wama Hagalo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819030",
    "IU name": "Wayu Tuka",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819033",
    "IU name": "Wuchale",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819036",
    "IU name": "Yabelo Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819037",
    "IU name": "Yaya Gulele",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819039",
    "IU name": "Yama Logi Welel",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195019193",
    "IU name": "Humbo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195019238",
    "IU name": "Ofa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119282",
    "IU name": "Atsbi Wenberta",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119285",
    "IU name": "Dega Temben",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119286",
    "IU name": "Alage",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119287",
    "IU name": "Endamehoni",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119290",
    "IU name": "Ganta Afeshum",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119296",
    "IU name": "Hintalo Wajirat",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119299",
    "IU name": "Kelete Awelallo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119301",
    "IU name": "Korem Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119305",
    "IU name": "Maychew Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119309",
    "IU name": "Ofla",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195119311",
    "IU name": "Raya Azebo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819331",
    "IU name": "Gololcha Bale",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819332",
    "IU name": "Goro (SW Shewa)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819338",
    "IU name": "Badele Zuria",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819341",
    "IU name": "Haro Walabu",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819342",
    "IU name": "Heban Arsi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194319349",
    "IU name": "Angot",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194319350",
    "IU name": "Gazo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194319351",
    "IU name": "Raya Kobo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194319352",
    "IU name": "Guna Begemider",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194319354",
    "IU name": "Sede Muja",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819359",
    "IU name": "Ginir Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819360",
    "IU name": "Dubluk",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819361",
    "IU name": "Elwaya",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819362",
    "IU name": "Gomole",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819363",
    "IU name": "Guchi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819364",
    "IU name": "Wachile",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819371",
    "IU name": "Choman Guduru",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819372",
    "IU name": "Horo Buluk",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819373",
    "IU name": "Halu (Huka)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819374",
    "IU name": "Botor Tolay",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819375",
    "IU name": "Mancho",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819378",
    "IU name": "Birbirsa Kojowa",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819379",
    "IU name": "Suro Berguda",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819380",
    "IU name": "Gumbi Bordede",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819382",
    "IU name": "Ejersa Lafo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819383",
    "IU name": "Liban Jawi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819384",
    "IU name": "Meta Walkite",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195019425",
    "IU name": "Bonke",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194319453",
    "IU name": "Lasta",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194319454",
    "IU name": "Meket",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194319456",
    "IU name": "Semada",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194419457",
    "IU name": "Bambasi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194419461",
    "IU name": "Maokomo Special",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819464",
    "IU name": "Arero",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819465",
    "IU name": "Dire",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819470",
    "IU name": "Yabelo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819471",
    "IU name": "Ginir",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819472",
    "IU name": "Moyale (Oromia)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819476",
    "IU name": "Uraga",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819477",
    "IU name": "Guduru",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819478",
    "IU name": "Horo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819479",
    "IU name": "Dedo",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819481",
    "IU name": "Arsi Negele",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819483",
    "IU name": "Bule Hora",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819486",
    "IU name": "Meta Robi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819518",
    "IU name": "Kercha",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819519",
    "IU name": "Ejere (Addis Alem)",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819522",
    "IU name": "Toke Kutaye",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195019577",
    "IU name": "Gidole Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195019578",
    "IU name": "Abela Abaya",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195019579",
    "IU name": "Gesuba Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195019580",
    "IU name": "Gununo Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195019581",
    "IU name": "Hobicha Abaya",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195019582",
    "IU name": "Kawo Koysha",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0195019583",
    "IU name": "Tabala Town",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194819590",
    "IU name": "Arda JIla",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194119591",
    "IU name": "Lemmi",
    "Category": "<1% prevalence (non-endemic)"
  },
  {
    "IU code": "ETH0194919071",
    "IU name": "Ferfer",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919077",
    "IU name": "Gode",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919081",
    "IU name": "Gunagado",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919086",
    "IU name": "Hargele",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919087",
    "IU name": "Harshin",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919095",
    "IU name": "Kelafo",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919099",
    "IU name": "Marsin",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919102",
    "IU name": "Mustahil",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919108",
    "IU name": "Shaygosh",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919109",
    "IU name": "Shilabo",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919110",
    "IU name": "Shinile",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919113",
    "IU name": "West Imi",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919114",
    "IU name": "Yocale",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019120",
    "IU name": "Abeshege",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219123",
    "IU name": "Aleta Wendo",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219124",
    "IU name": "Chuko",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319140",
    "IU name": "Bero",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219162",
    "IU name": "Dale",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019166",
    "IU name": "Dasenech (Kuraz)",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019180",
    "IU name": "Geze Gofa",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319192",
    "IU name": "Gurafereda",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019204",
    "IU name": "Jinka Town Admin",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319214",
    "IU name": "Ela (Konta) SP Woreda",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019222",
    "IU name": "Male",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019235",
    "IU name": "South Ari (Bako Gazer)",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319249",
    "IU name": "Sheka",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019253",
    "IU name": "Gelila / North Ari",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319254",
    "IU name": "Debub Bench",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319255",
    "IU name": "Surma",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319272",
    "IU name": "Yeki",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919393",
    "IU name": "Harawo",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919403",
    "IU name": "El-Ogaden",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919405",
    "IU name": "Higloley",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194619462",
    "IU name": "Dima",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919495",
    "IU name": "Debeweyin",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219517",
    "IU name": "Wondo-Genet",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919525",
    "IU name": "Barey",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319535",
    "IU name": "Disa Denba",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319555",
    "IU name": "Goba",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019596",
    "IU name": "Leha Town",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019609",
    "IU name": "Gazer Town",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319617",
    "IU name": "Ameya Zuria",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919625",
    "IU name": "Gota-Biki",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194718731",
    "IU name": "Erer (Harari)",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194718735",
    "IU name": "Sofi",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919044",
    "IU name": "Afdem",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919070",
    "IU name": "Erer (Somali)",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919072",
    "IU name": "Filtu",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919080",
    "IU name": "Goro Baqaqsa",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919082",
    "IU name": "Guradamole",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919101",
    "IU name": "Mubarek",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194218501",
    "IU name": "Amibara",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318502",
    "IU name": "Argoba",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194218506",
    "IU name": "Asayita",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194218515",
    "IU name": "Dulecha",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318533",
    "IU name": "Addi Arekay",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318535",
    "IU name": "Alfa",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318538",
    "IU name": "Aneded",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318542",
    "IU name": "Antsokiya",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318546",
    "IU name": "Awabel",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318548",
    "IU name": "Bahir Dar Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318550",
    "IU name": "Baso Liben",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318558",
    "IU name": "Bugna",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318560",
    "IU name": "Bure (Amhara)",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318566",
    "IU name": "Dabat",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318570",
    "IU name": "Dawunt",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318572",
    "IU name": "Debark Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318573",
    "IU name": "Debay Telatgen",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318574",
    "IU name": "Debre Tabor Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318580",
    "IU name": "Delanta",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318589",
    "IU name": "Enebse Sarmder",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318592",
    "IU name": "East Esite",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318603",
    "IU name": "Gonder Zuria",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318604",
    "IU name": "Gonje",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318606",
    "IU name": "Guagusa Shikudad",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318614",
    "IU name": "Jama",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318618",
    "IU name": "Kalu",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318623",
    "IU name": "Kombolcha Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318625",
    "IU name": "Lalibela Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318630",
    "IU name": "Libokemekem",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318635",
    "IU name": "Mekdela",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318636",
    "IU name": "Menze Gera Midir",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318637",
    "IU name": "Menze Keya Gabriel",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318658",
    "IU name": "Debub Achefer",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318667",
    "IU name": "Tarema Ber",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318674",
    "IU name": "Woldiya Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318675",
    "IU name": "Wemberma",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318678",
    "IU name": "Yilmana Densa",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318681",
    "IU name": "Legambo",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318682",
    "IU name": "Wegde",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318683",
    "IU name": "Were Ilu",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194418685",
    "IU name": "Assosa Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194418695",
    "IU name": "Kurmuk",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194418703",
    "IU name": "Wenbera",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818736",
    "IU name": "Ada'a",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818740",
    "IU name": "Abaya",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818747",
    "IU name": "Adama Tulu Jido Kombolcha",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818753",
    "IU name": "Akaki",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818754",
    "IU name": "Ale",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818757",
    "IU name": "Ambo Zuria",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818759",
    "IU name": "Amigna",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818760",
    "IU name": "Amuru",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818768",
    "IU name": "Asela Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818769",
    "IU name": "Aweday Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818771",
    "IU name": "Boji Dirmeji",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818772",
    "IU name": "Babo",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818773",
    "IU name": "Becho (Ilu Aba Bora)",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818788",
    "IU name": "Bishan Guracha",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818789",
    "IU name": "Bishoftu Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818792",
    "IU name": "Bora",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818797",
    "IU name": "Bule Hora Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818799",
    "IU name": "Bure (Oromia)",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818803",
    "IU name": "Chinaksen",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818806",
    "IU name": "Chole",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818816",
    "IU name": "Daro Lebu",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818818",
    "IU name": "Deder",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818819",
    "IU name": "Deder Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818822",
    "IU name": "Degem",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818826",
    "IU name": "Dera (Oromia)",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818827",
    "IU name": "Dawe Ketchen",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818834",
    "IU name": "Diksis",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818836",
    "IU name": "Dinsho",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818849",
    "IU name": "Fentale",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818850",
    "IU name": "Fedis",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818853",
    "IU name": "Gimbi",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818854",
    "IU name": "Gimbi Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818855",
    "IU name": "Gimbichu",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818859",
    "IU name": "Gasera",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818866",
    "IU name": "Gida Ayana",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818880",
    "IU name": "Gora Dola",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818882",
    "IU name": "Goba Koricha",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818886",
    "IU name": "Guna",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818887",
    "IU name": "Gura Damole",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818889",
    "IU name": "Gursum (Oromia)",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818892",
    "IU name": "Haru",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818893",
    "IU name": "Homa",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818895",
    "IU name": "Habro",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818902",
    "IU name": "Hawi Gudina",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818905",
    "IU name": "Hidabu Abote",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818906",
    "IU name": "Holeta Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818910",
    "IU name": "Ifata",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818915",
    "IU name": "Jeju",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818918",
    "IU name": "Jida",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818924",
    "IU name": "Kiltu Kara",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818926",
    "IU name": "Gudetu Kondole",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818939",
    "IU name": "Liben Chukala",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818942",
    "IU name": "Lege Tafo-Lege Dadi Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194318943",
    "IU name": "Legehida",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818947",
    "IU name": "Limu Kosa",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818956",
    "IU name": "Melka Soda",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818962",
    "IU name": "Metu Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818964",
    "IU name": "Mida Kegn",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818965",
    "IU name": "Midhaga Tola",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818972",
    "IU name": "Nejo Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818975",
    "IU name": "Nenesebo (Wereka)",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818976",
    "IU name": "Nekemte Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194818987",
    "IU name": "Robe Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819003",
    "IU name": "Shambu Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819008",
    "IU name": "Sigmo",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819009",
    "IU name": "Sinana",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819013",
    "IU name": "Sude",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819022",
    "IU name": "Tulo (Oromia)",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819025",
    "IU name": "Woliso Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819029",
    "IU name": "Wara Jarso",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819031",
    "IU name": "Welmera",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819034",
    "IU name": "Yubdo",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819038",
    "IU name": "Yayu",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819041",
    "IU name": "Kimbibit",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819042",
    "IU name": "Kuyu",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195019132",
    "IU name": "Boditi Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195019154",
    "IU name": "Damot Sore",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195019161",
    "IU name": "Diguna Fango",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195019209",
    "IU name": "Kindo Koyesha",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195019219",
    "IU name": "Mirab Abaya",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195019241",
    "IU name": "Sodo Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195019242",
    "IU name": "Sodo Zuria",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119276",
    "IU name": "Adhaki",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119279",
    "IU name": "Adigrat Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119283",
    "IU name": "Axum Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119284",
    "IU name": "Ayder",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119293",
    "IU name": "Hadnet",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119294",
    "IU name": "Hawelti",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119298",
    "IU name": "Kedamay Weyane",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119302",
    "IU name": "Kuha",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119313",
    "IU name": "Saesie Tsaedamba",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119314",
    "IU name": "Saharti Samre",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119315",
    "IU name": "Debub & Semen Mekele",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119316",
    "IU name": "Setit Humera",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195119327",
    "IU name": "Wukro Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819335",
    "IU name": "Shashemene Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819339",
    "IU name": "Dega",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194319344",
    "IU name": "Ayehu Guwagusa",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194319353",
    "IU name": "Mena Meketewa",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819365",
    "IU name": "Babile Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819377",
    "IU name": "Sedi Chenka",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819381",
    "IU name": "Cobi",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819385",
    "IU name": "Leta Sibu",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819386",
    "IU name": "Mendi Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194319449",
    "IU name": "Ankasha",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194319452",
    "IU name": "Kobo Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194319455",
    "IU name": "Ebenat",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194419458",
    "IU name": "Homosha",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819473",
    "IU name": "Babile (Oromia)",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819484",
    "IU name": "Mieso",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819485",
    "IU name": "Jeldu",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819488",
    "IU name": "Nejo",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819489",
    "IU name": "Mana Sibu",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819521",
    "IU name": "Diga",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0194819524",
    "IU name": "Dale Wabera",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195019568",
    "IU name": "Bayera Koisha",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195019611",
    "IU name": "Belle Town",
    "Category": "1 - 9.9% prevalence (low)"
  },
  {
    "IU code": "ETH0195319221",
    "IU name": "Maji",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219227",
    "IU name": "Malga",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319228",
    "IU name": "Menit Goldiye",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319229",
    "IU name": "Menit Shasha",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319233",
    "IU name": "Mizan Aman Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319236",
    "IU name": "Semen Bench",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019237",
    "IU name": "Gnangatom",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019239",
    "IU name": "Ayida",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019240",
    "IU name": "Sawla Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019246",
    "IU name": "Shashogo",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319248",
    "IU name": "Shey Bench",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319258",
    "IU name": "Tepi Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019261",
    "IU name": "Ouba Debretsehaye",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019265",
    "IU name": "Wenago",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219267",
    "IU name": "Wonosho",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219269",
    "IU name": "Yirgalem Town Adm.",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019271",
    "IU name": "Yirgachefe",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019273",
    "IU name": "Yem SP Woreda",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019274",
    "IU name": "Zala",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019336",
    "IU name": "Yirgachefe Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919343",
    "IU name": "Horshagah",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919387",
    "IU name": "God-God",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919390",
    "IU name": "Lehel-Yucub",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919391",
    "IU name": "Wangey",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919396",
    "IU name": "Koran/Mulla",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919397",
    "IU name": "Shabeeley",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919400",
    "IU name": "Ayun",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919401",
    "IU name": "Hararey",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919404",
    "IU name": "Goglo",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919406",
    "IU name": "Lasdhankayre",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019427",
    "IU name": "Kucha Alpha",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219438",
    "IU name": "Bilate Zuria",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219442",
    "IU name": "Darara",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219444",
    "IU name": "Hawela",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219445",
    "IU name": "Leku Town Administration",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019220",
    "IU name": "Melekoza",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019243",
    "IU name": "Selamgo",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919389",
    "IU name": "Gablalu",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919624",
    "IU name": "Dunyar",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919626",
    "IU name": "Bokolmayo",
    "Category": ">=50% post-IA prevalence"
  },
  {
    "IU code": "ETH0194618715",
    "IU name": "Akobo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194618721",
    "IU name": "Jikawo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194618724",
    "IU name": "Makuey",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194618726",
    "IU name": "Wantawo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194918775",
    "IU name": "Babile",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919046",
    "IU name": "Aware",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919052",
    "IU name": "Burqod",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919053",
    "IU name": "Bokh",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919055",
    "IU name": "Charati",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919057",
    "IU name": "Degahabur City",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919061",
    "IU name": "Daratole",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919073",
    "IU name": "Fik",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919075",
    "IU name": "Garbo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919078",
    "IU name": "Godey City",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919088",
    "IU name": "Hudet",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919092",
    "IU name": "Kebridehar City",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919097",
    "IU name": "Meyumuluka",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919098",
    "IU name": "Miesso",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019115",
    "IU name": "Alle Special",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019117",
    "IU name": "Anigacha",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019125",
    "IU name": "Alicho Woriro",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019127",
    "IU name": "Analemmo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219130",
    "IU name": "Aroresa",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019131",
    "IU name": "Basketo SP Woreda",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019136",
    "IU name": "Boreda",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019137",
    "IU name": "Burji Special",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219142",
    "IU name": "Bona Zuria",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319143",
    "IU name": "Bonga Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219146",
    "IU name": "Bursa",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019147",
    "IU name": "Butajira Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319151",
    "IU name": "Cheta",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019160",
    "IU name": "Dita",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019163",
    "IU name": "Dalocha",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319167",
    "IU name": "Decha",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019171",
    "IU name": "Doya Gena",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019172",
    "IU name": "Dune",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019173",
    "IU name": "Durame Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019174",
    "IU name": "Mierab Azenet Berbere",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019175",
    "IU name": "Mirab Badowach",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019176",
    "IU name": "Endiguagn",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019177",
    "IU name": "Enemorina Eaner",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019179",
    "IU name": "Ezha",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019182",
    "IU name": "Gedebano Gutazer Welene",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319183",
    "IU name": "Gena",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319184",
    "IU name": "Gesha (Deka)",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194318532",
    "IU name": "Abergele",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318536",
    "IU name": "Ambasel",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318537",
    "IU name": "West Esite",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318541",
    "IU name": "Ankober",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318547",
    "IU name": "Bahirdar Zuria",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318552",
    "IU name": "Bati",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318553",
    "IU name": "Bati Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318554",
    "IU name": "Berehet",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318556",
    "IU name": "Bibugn",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318561",
    "IU name": "Chagni Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318583",
    "IU name": "Dera (Amhara)",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318587",
    "IU name": "Eferatana Gidem",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318595",
    "IU name": "Finote Selam Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318598",
    "IU name": "Gendawuha Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318602",
    "IU name": "Gonder City Adm.",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318613",
    "IU name": "Jabi Tehnan",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318619",
    "IU name": "Kelela",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318629",
    "IU name": "Borena / Debresina",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318645",
    "IU name": "West Belesa",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318646",
    "IU name": "East Belesa",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318649",
    "IU name": "Mota Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318650",
    "IU name": "Quara",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318654",
    "IU name": "Siya Debirna Wayu",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318659",
    "IU name": "Shebel Bernta",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194318668",
    "IU name": "Thehulederie",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194418686",
    "IU name": "Assosa",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194418688",
    "IU name": "Belojiganfo",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194418690",
    "IU name": "Dangura",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194418691",
    "IU name": "Debati",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194418692",
    "IU name": "Guba",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194418699",
    "IU name": "Oda Bilidigilu",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194418702",
    "IU name": "Sherkole",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818737",
    "IU name": "Ayira",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818739",
    "IU name": "Abay Chomen",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818741",
    "IU name": "Abe Dongoro",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818745",
    "IU name": "Adama",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818746",
    "IU name": "Adama Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818749",
    "IU name": "Adola Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818750",
    "IU name": "Adola",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818751",
    "IU name": "Agarfa",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818752",
    "IU name": "Agaro Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818762",
    "IU name": "Anchar",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818776",
    "IU name": "Bedesa",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818790",
    "IU name": "Boke",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818794",
    "IU name": "Borecha",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818800",
    "IU name": "Burqua Dhintu",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818802",
    "IU name": "Chwaka",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818804",
    "IU name": "Chiro Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818805",
    "IU name": "Chiro Zuria",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818810",
    "IU name": "Dabo Hana",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818823",
    "IU name": "Mena (Bale)",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818839",
    "IU name": "Doba",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818844",
    "IU name": "Dugda",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818864",
    "IU name": "Gemechis",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818876",
    "IU name": "Golo Oda",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818881",
    "IU name": "Goro Gutu",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818885",
    "IU name": "Gumay",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818888",
    "IU name": "Girawa",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818890",
    "IU name": "Guto Gida",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818897",
    "IU name": "Hambela Wamena",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818898",
    "IU name": "Harena Buluk",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818912",
    "IU name": "Jarso (East Hararghe)",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818923",
    "IU name": "Jimma/Town/",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818928",
    "IU name": "Kersa (Jimma)",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818932",
    "IU name": "Kombolcha",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818934",
    "IU name": "Kumbi",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818953",
    "IU name": "Mena (Jimma)",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818954",
    "IU name": "Meda Welabu",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818957",
    "IU name": "Merti",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818958",
    "IU name": "Mesela",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818963",
    "IU name": "Meyu Muleke",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818974",
    "IU name": "Negele /Town/",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818977",
    "IU name": "Nono",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818981",
    "IU name": "Kuni",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818991",
    "IU name": "Sasiga",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194818995",
    "IU name": "Seka Chekorsa",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819019",
    "IU name": "Tiro Afeta",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819027",
    "IU name": "Wadera",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819032",
    "IU name": "Wondo",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819040",
    "IU name": "Ziway Dugda",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195019119",
    "IU name": "Areka Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195019134",
    "IU name": "Boloso Sore",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195019155",
    "IU name": "Damot Gale",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195019156",
    "IU name": "Damot Pulasa",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195019157",
    "IU name": "Damot Weydie",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195019208",
    "IU name": "Kindo Didaye",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119275",
    "IU name": "Abi Adi Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119277",
    "IU name": "Adwa Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119288",
    "IU name": "Enderta",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119289",
    "IU name": "Erob",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119291",
    "IU name": "Adwa",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119292",
    "IU name": "Gulo Mekeda",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119295",
    "IU name": "Hawzen",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119300",
    "IU name": "Kola Temben",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119303",
    "IU name": "Laelay Adiabo",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119304",
    "IU name": "Laelay Maychew",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119306",
    "IU name": "Medebay Zana",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119308",
    "IU name": "Naeder Adet",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119310",
    "IU name": "Alamata",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119317",
    "IU name": "Shire",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119318",
    "IU name": "Sheraro Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119319",
    "IU name": "Tahtay Koraro",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119320",
    "IU name": "Tahtay Adiyabo",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119321",
    "IU name": "Tahtay Mayechew",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119323",
    "IU name": "Tsegede (Tigray)",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119326",
    "IU name": "Werei Leke",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195119328",
    "IU name": "Alamata Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819334",
    "IU name": "Kersa (East Hararge)",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319345",
    "IU name": "Sedae",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319346",
    "IU name": "East Dembia",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319347",
    "IU name": "Kinfaz",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319348",
    "IU name": "West Dembiya",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319356",
    "IU name": "Mecha",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319357",
    "IU name": "Debub Mecha",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819358",
    "IU name": "Shanan Kolu",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819368",
    "IU name": "Aga Wayu",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819370",
    "IU name": "Shakiso Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319408",
    "IU name": "Chilga 1",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319409",
    "IU name": "Chilga 2",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194419410",
    "IU name": "Kamashi Town",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319450",
    "IU name": "Hulet Ej Enese",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319451",
    "IU name": "Wegera",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194419459",
    "IU name": "Kamashi",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819469",
    "IU name": "Golocha",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819474",
    "IU name": "Saba Boru",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194819475",
    "IU name": "Odo Shakiso",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194319529",
    "IU name": "Adagnehagre chako",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0194852964",
    "IU name": "Lege Hida",
    "Category": "10 - 49.9% prevalence (moderate)"
  },
  {
    "IU code": "ETH0195219447",
    "IU name": "Teticha",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219448",
    "IU name": "Wondo-Genet Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194619463",
    "IU name": "Gog",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219468",
    "IU name": "Hawasa Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919490",
    "IU name": "Kebribeyah",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919493",
    "IU name": "Qubi",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919494",
    "IU name": "Aw-Bare",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919497",
    "IU name": "Danan",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919498",
    "IU name": "East Imi",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919500",
    "IU name": "Hadhagala",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194619501",
    "IU name": "Itang",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019502",
    "IU name": "Kucha",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219505",
    "IU name": "Boricha",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219506",
    "IU name": "Shebe Dino",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194619508",
    "IU name": "Gambela Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219516",
    "IU name": "Hulla",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919527",
    "IU name": "Warder",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219528",
    "IU name": "Chire",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194218513",
    "IU name": "Dewe",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318544",
    "IU name": "Artuma Fursi",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318555",
    "IU name": "Beyeda",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318569",
    "IU name": "Dewa Harewa",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318579",
    "IU name": "Dejen",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318585",
    "IU name": "Dewa Cheffa",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318616",
    "IU name": "Jawi",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318617",
    "IU name": "Jilye Tumuga",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318620",
    "IU name": "Kemisie Town",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318621",
    "IU name": "Kewet",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318627",
    "IU name": "Lay Armacho",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318641",
    "IU name": "Metema",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318644",
    "IU name": "Mirab Armacho",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318656",
    "IU name": "Sekota Town",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318660",
    "IU name": "Shoa Robit",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318665",
    "IU name": "Tach Armacho",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318666",
    "IU name": "Takusa",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318670",
    "IU name": "Tsegede (Amhara)",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194318671",
    "IU name": "Telemt",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194418684",
    "IU name": "Agalometi",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194418689",
    "IU name": "Bulen",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194418698",
    "IU name": "Menge",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194418700",
    "IU name": "Pawe",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194418701",
    "IU name": "Sodal/Sirba Abay",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194418704",
    "IU name": "Yaso",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194818783",
    "IU name": "Bedeno",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194818872",
    "IU name": "Girja (Harenfema)",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194818878",
    "IU name": "Goma",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194818901",
    "IU name": "Haro Maya",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194818903",
    "IU name": "Hawa Galan",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194818935",
    "IU name": "Kurfa Chele",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194818955",
    "IU name": "Melka Balo",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194818997",
    "IU name": "Seru",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0195019133",
    "IU name": "Boloso Bombe",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0195119278",
    "IU name": "Aheferom",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0195119281",
    "IU name": "Asgede Tsimbila",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0195119297",
    "IU name": "Kafta Humera",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0195119307",
    "IU name": "Mereb Lehe",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0195119322",
    "IU name": "Tanqua Abergele",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0195119324",
    "IU name": "Tselemti",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0195119325",
    "IU name": "Welkait",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194819333",
    "IU name": "Haromaya Town",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194319355",
    "IU name": "Tsagbeji",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194819366",
    "IU name": "Goro Muti",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194819369",
    "IU name": "Gumi Idalo",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194819376",
    "IU name": "Omo Beyam",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194419411",
    "IU name": "Gilgel Beles Town",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194419460",
    "IU name": "Mandura",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194319466",
    "IU name": "Sekota",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194819467",
    "IU name": "Meta",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194819480",
    "IU name": "Omo Nada",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194819491",
    "IU name": "Liben",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194419530",
    "IU name": "Undulu",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0194319570",
    "IU name": "Central Armachiho",
    "Category": ">=50% prevalence (high)"
  },
  {
    "IU code": "ETH0195319531",
    "IU name": "Gachit",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319532",
    "IU name": "Gidi Bench",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319533",
    "IU name": "Gori gesha",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195319536",
    "IU name": "Kache",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019545",
    "IU name": "Mello Gada",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019546",
    "IU name": "Chelelektu Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019547",
    "IU name": "Kedida  Gubeta",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019548",
    "IU name": "Rape",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019559",
    "IU name": "Karat Zuria",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019566",
    "IU name": "Baka Dawula Ari",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019567",
    "IU name": "Wub Ari",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219584",
    "IU name": "Chuko Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219586",
    "IU name": "Dara Otilcho",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195219587",
    "IU name": "Hoko",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019592",
    "IU name": "Gerese",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019595",
    "IU name": "Wonago Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019597",
    "IU name": "Betto Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019602",
    "IU name": "Angecha Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019610",
    "IU name": "Kelle Town",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919628",
    "IU name": "Aba-Korow",
    "Category": "1 - 9.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194518705",
    "IU name": "Addis Ketema (Dire Dawa)",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194518706",
    "IU name": "Biyoawale",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194518708",
    "IU name": "Gende Kore",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194518709",
    "IU name": "Jeldessa",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194518710",
    "IU name": "Legehare",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194518711",
    "IU name": "Malka Jabti (M/jebdu)",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194518712",
    "IU name": "Sabian",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194518713",
    "IU name": "Wahil",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194618717",
    "IU name": "Gambela Zuria",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194618718",
    "IU name": "Godere",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194618725",
    "IU name": "Mengesh",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194718727",
    "IU name": "Abadir",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194718728",
    "IU name": "Aboker",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194718729",
    "IU name": "Amir Nur",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194718730",
    "IU name": "Dire Teyara",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194718732",
    "IU name": "Hakim",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194718733",
    "IU name": "Jinela",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194718734",
    "IU name": "Shenkor",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919048",
    "IU name": "Ayisha",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919062",
    "IU name": "Daror",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919063",
    "IU name": "Deka Suftu",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919067",
    "IU name": "Dolobay",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0194919069",
    "IU name": "Elkare/Serer",
    "Category": "10 - 49.9% post-IA prevalence"
  },
  {
    "IU code": "ETH0195019185",
    "IU name": "Geta",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319186",
    "IU name": "Gewata",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019187",
    "IU name": "Gibe",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319188",
    "IU name": "Gimbo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019189",
    "IU name": "Gombora",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019191",
    "IU name": "Gumer",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019201",
    "IU name": "Hosaena Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019203",
    "IU name": "Wilbareg",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019215",
    "IU name": "Lanfero",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319223",
    "IU name": "Mareka",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019224",
    "IU name": "Mareko",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319225",
    "IU name": "Masha Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319226",
    "IU name": "Masha",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319230",
    "IU name": "Menjiwo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019231",
    "IU name": "Meskan",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019232",
    "IU name": "Misha",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019234",
    "IU name": "Muhur Na Aklil",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019244",
    "IU name": "Sankura",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319245",
    "IU name": "Sayilem",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019250",
    "IU name": "Silti",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019251",
    "IU name": "Sodo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019252",
    "IU name": "Soro",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319256",
    "IU name": "Tulo (SNNP)",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019257",
    "IU name": "Tembaro",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319259",
    "IU name": "Tercha Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319260",
    "IU name": "Tocha",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019262",
    "IU name": "Misrak Azenet Berbere",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019264",
    "IU name": "Welkite Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019268",
    "IU name": "Worabe Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919388",
    "IU name": "Kohle/Qoxle",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919392",
    "IU name": "Yahob",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919394",
    "IU name": "Haroreys",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919395",
    "IU name": "Kebribayah Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919398",
    "IU name": "Wajale City",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919399",
    "IU name": "Qada Duma",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919402",
    "IU name": "Bodaley",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019426",
    "IU name": "Chencha",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019428",
    "IU name": "Garda Marta",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019429",
    "IU name": "Selamber Town Admin",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019430",
    "IU name": "Shone Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019431",
    "IU name": "Atote Ulo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019432",
    "IU name": "Wera",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019433",
    "IU name": "Wera Djo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019434",
    "IU name": "Adilo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019435",
    "IU name": "Hadero Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019436",
    "IU name": "Shinshecho Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219439",
    "IU name": "Bura",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219440",
    "IU name": "Chabe Gambeltu",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219441",
    "IU name": "Daella",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219443",
    "IU name": "Daye Town Administration",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219446",
    "IU name": "Shafamo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919492",
    "IU name": "Salahad",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919496",
    "IU name": "Moyale (Somali)",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919499",
    "IU name": "Sagag",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019503",
    "IU name": "Kulito Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219504",
    "IU name": "Bensa",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019507",
    "IU name": "Bonke Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019509",
    "IU name": "Chencha Zuriya",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019511",
    "IU name": "Misrak Badawacho",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019512",
    "IU name": "Kediada Gambela",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019513",
    "IU name": "Hadero Tunto",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019514",
    "IU name": "Kacha Bira",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219515",
    "IU name": "Arbe Gonna",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919526",
    "IU name": "Galadi",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319537",
    "IU name": "Mari Mansa",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319538",
    "IU name": "Tercha Zuriya",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319539",
    "IU name": "Zabagazo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019540",
    "IU name": "Bui Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019541",
    "IU name": "Misrak Meskan",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019542",
    "IU name": "Debub Sodo",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019543",
    "IU name": "Bulike town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019544",
    "IU name": "Kogota",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019549",
    "IU name": "Emdebir town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019550",
    "IU name": "Ameke",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019551",
    "IU name": "Gimbichu town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019552",
    "IU name": "Jajura Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019553",
    "IU name": "Mirab Soro",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019554",
    "IU name": "Siraro Badewacho",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319556",
    "IU name": "Shisho Ande",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319557",
    "IU name": "Wacha",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019558",
    "IU name": "Karat Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019560",
    "IU name": "Kena",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019561",
    "IU name": "Segen Zuria",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019562",
    "IU name": "Misirak Silti",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019563",
    "IU name": "Kibet Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019564",
    "IU name": "Mito",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019565",
    "IU name": "Tora Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319572",
    "IU name": "Seize town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019573",
    "IU name": "Gecho Baba",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019574",
    "IU name": "Kemba Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019575",
    "IU name": "Gedeb Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019576",
    "IU name": "Enor Ener",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195219585",
    "IU name": "Chirone",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019588",
    "IU name": "Laska Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019593",
    "IU name": "Gerese Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019594",
    "IU name": "Biribir Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019598",
    "IU name": "Gonchire Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019599",
    "IU name": "Fonko Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019600",
    "IU name": "Homecho Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019601",
    "IU name": "Bonosha Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019603",
    "IU name": "Damboya Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019604",
    "IU name": "Doya Gena Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019605",
    "IU name": "Mudola Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019606",
    "IU name": "Dalocha Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019607",
    "IU name": "Alem Gebeya Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195019608",
    "IU name": "Turmi Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319612",
    "IU name": "Gesa Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319613",
    "IU name": "Awurada Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319614",
    "IU name": "Deka town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319615",
    "IU name": "Shisho Ande Town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319616",
    "IU name": "Ameya town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319618",
    "IU name": "Chida town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319619",
    "IU name": "Ela Hanchano",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319620",
    "IU name": "Maji Tum town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319621",
    "IU name": "Jemu town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0195319622",
    "IU name": "Bachuma town",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919623",
    "IU name": "Daymed",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194919627",
    "IU name": "Galhamur",
    "Category": "Surveillance (prevalence <1%)"
  },
  {
    "IU code": "ETH0194818914",
    "IU name": "Jarso (West Wellega)",
    "Category": "Endemicity unknown"
  },
  {
    "IU code": "ETH0195019437",
    "IU name": "Segen Town",
    "Category": "No data available"
  }
]